import { render, staticRenderFns } from "./RegistrationTraineeModal.vue?vue&type=template&id=7c4be7b2"
import script from "./RegistrationTraineeModal.vue?vue&type=script&lang=js"
export * from "./RegistrationTraineeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports